// extracted by mini-css-extract-plugin
module.exports = {"Outer":"NewPie_Outer__2MqWW","innerText":"NewPie_innerText__29zRn","afterDecimal":"NewPie_afterDecimal__nOV3n","pieCard":"NewPie_pieCard__7lk4-"};